const ANALYTICS_BASE_URL =
  process.env.REACT_APP_VENDOR_ANALYTICS_API || "https://api.cupvisor.org/vendor_analytic_dashboard";

export async function fetchVendorAnalytics(vendorId, getToken) {
  if (!vendorId) throw new Error("vendorId is required");
  const res = await fetch(`${ANALYTICS_BASE_URL}/${vendorId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${await getToken()}`,
    },
  });
  if (!res.ok) {
    const txt = await res.text();
    throw new Error(`Analytics fetch failed (${res.status}): ${txt}`);
  }
  return res.json();
}
